import reducer from 'state/mrDistribution/extras/reducer';
import actions from 'state/mrDistribution/extras/actionCreators';

export { actions };

export default reducer;
